function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxInviteAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.81 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 75") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.22,142.92c0,3.91-18.33,7.08-40.94,7.08s-40.94-3.17-40.94-7.08c0-1,1.14-1.91,3.21-2.75,6-2.47,19.9-4.22,36.21-4.32h1.52C64.89,135.84,83.22,139,83.22,142.92Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.76,135.85a23.24,23.24,0,0,1-36.21,4.32C10.58,137.7,24.45,136,40.76,135.85Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.43,
    cy: 120.16,
    rx: 21.43,
    ry: 22.96,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72,15.94c3,11.7,12.84,19.27,21.91,16.91",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.63,32.86C66.56,21,72.26,9.32,82.39,6.69",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.94,15.46c2.89,11.12,9.9,18.9,15.69,17.4",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.63,32.86C65.7,17.73,72,3,83.7,0",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.21,33.9a8.81,8.81,0,0,0,2.88-1.36c.57-.68,3.3-2,3.68-1.27s4.53,3.08,1.91,3.78-6.21,1.18-7,.93S66.21,33.9,66.21,33.9Z",
    style: {
      fill: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.66,34.76c-2.62.7-6.21,1.18-7,.93-.62-.19-1.13-1.3-1.34-1.82l-.08,0s.63,1.84,1.45,2.08,4.4-.23,7-.93c.76-.2.95-.54.83-.94C75.47,34.39,75.22,34.61,74.66,34.76Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.62,
    y: 24.12,
    width: 154.19,
    height: 89.34,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.25,
    y: 51.24,
    width: 84.56,
    height: 44.29,
    style: {
      fill: "#3fa9f5",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.32,
    y: 49.31,
    width: 33.92,
    height: 1.88,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.32,
    y: 52.77,
    width: 49.36,
    height: 1.88,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.32,
    y: 61.14,
    width: 33.92,
    height: 1.88,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.32,
    y: 75,
    width: 33.92,
    height: 1.88,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.32,
    y: 64.6,
    width: 49.36,
    height: 1.88,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.32,
    y: 68.07,
    width: 49.36,
    height: 1.88,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.32,
    y: 71.53,
    width: 49.36,
    height: 1.88,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.32,
    y: 83.37,
    width: 17.75,
    height: 4.91,
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.16,78s3.19-9,5.49-6.2-3.54,7.61-3.54,7.61Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.12,69.19,47,69.9s.92,4.07.56,4.78-.53.18,0,1.59,2.12,5.13,2.3,5.67,10.27-3.36,10.27-5.31a18,18,0,0,0,3.19,3s-11.68,8.5-13.28,9.56-2.48.53-3.89-.71S38.74,77,38.74,77Z",
    style: {
      fill: "#575a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25,132s-.18,1.95-.53,2.12-3,4.6,0,5.49,4.78.53,5.49.89,13.1,1.06,13.28-.89-6-2.3-6-2.3-5.66-3.72-6.55-5.66S50.25,132,50.25,132Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31,135.57s-4.25,7.26-3.19,8.14S22.53,147.83,24,148c1.95.18,3.36-1.42,1.77-2.3s-5-4.6-5-5.84v-3.19Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.24,88.13s-3.72,4.6,2.12,12l9.74,12.39s-6,9.56-6.2,14.52-1.42,3.89-1.77,6-1.95,1.06-.71,2.66,5.84,3,7.26,1.77A4.39,4.39,0,0,0,22.1,134c0-.71,2.48-4.78,2.66-6s6.73-11.33,6.73-11.33,2.12-6-.35-9.38A35.56,35.56,0,0,1,27,99.11s7.3,8.84,12.44,11c0,0,1.95.35,1.59,1.24s0,1.42.53,2.3,4.25,11.15,5.49,13.81.71,4.25,2.12,5.13,7.79.18,7.79-.71a18,18,0,0,0-1.42-4.43c-.53-1.24-4.78-15.58-4.43-18.06s-.18-5.84-2.83-7.26S32.19,89.19,31.48,89.19,10.24,88.13,10.24,88.13Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.82,
    cy: 52.9,
    r: 7.44,
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81,53.61s-2.3,4.07-5.13,4.6,7.44,8.67,7.44,8.67,2.48-7.79,4.6-8.14S39.81,53.61,39.81,53.61Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.06,70.25c0,2.3-6.9,8.85-6.9,8.85l-6.55,5.49s-.18,1.95-.89,2.12-1.59.18-.89,1.24,2.48,3.36.89,3.72a13,13,0,0,1-1.45.14l-1.49.07c-1.31,0-2.95.08-4.72.06l-1.54,0c-6.69-.13-14.45-.9-13.81-3.44,1.06-4.25.35-5.67,2.66-8s6-10.27,6-10.27S25.82,57.68,32,57.68l1.29-.34a3,3,0,0,1,3.22,1.24,32.6,32.6,0,0,0,4.35,5.65c1.77,1.42,2,.4,2,.4S47.06,67.95,47.06,70.25Z",
    style: {
      fill: "#575a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.31,97.16s5.13,8,1.95,9.38-5-8.32-5-8.32Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,52.06c.29,0,.38-.4.42-.68a3.82,3.82,0,0,1,2.91-3.2,4.12,4.12,0,0,1,1.73.14,6.58,6.58,0,0,1,2.22,1.09,3.67,3.67,0,0,0,1.11.7c.28.08,1.46.61,1.74.7.61.2,1.11.83,1.74.71s.83-.84.92-1.45a7.61,7.61,0,0,0-1.35-4.58,4.86,4.86,0,0,0-2.61-1.71,18.72,18.72,0,0,0-3.61-.72,11.68,11.68,0,0,0-5,.21,4.73,4.73,0,0,0-3.32,3.4c-.06.34-.07.69-.15,1a15.31,15.31,0,0,1-1,2.3,4.44,4.44,0,0,0,.14,3.6c.44.89,1.21,1.74,1,2.72l1.37-1.08a1,1,0,0,0,.46-1.16l-.2-1.71a1.51,1.51,0,0,1,.09-.92C40.22,50.39,40.49,52.12,41,52.06Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.12,84.94l1.67,6.93c-1.68.06-3.91.09-6.27,0-.59-1.78-1.16-3.65-1.6-5.39C20.33,80.16,23,70.42,24.4,65.82a8.89,8.89,0,0,1,5-5.84,16.14,16.14,0,0,1,4.07,2.12C35.73,63.7,28.12,84.94,28.12,84.94Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.54,84.59l1.74,7.22-1.49.07c-1.31,0-2.95.08-4.72.06-.64-1.9-1.26-3.9-1.72-5.76-1.59-6.37,1.06-16.11,2.48-20.71s4.51.44,4.51.44-1.24-3,1.06-1.42S29.54,84.59,29.54,84.59Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.07,59.63a8.89,8.89,0,0,0-5,5.84C23.7,70.07,21,79.81,22.63,86.18a119.34,119.34,0,0,0,5,14.34S31,98,32.19,98.57l-3.36-14s7.61-21.24,5.31-22.84A16.15,16.15,0,0,0,30.07,59.63Z",
    style: {
      fill: "#575a89"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.62,
    y: 46.65,
    width: 84.56,
    height: 44.29,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.47,
    cy: 69.66,
    rx: 9.57,
    ry: 9.59,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,58.44a11.44,11.44,0,1,0,11.44,11.44A11.44,11.44,0,0,0,109.47,58.44ZM107.12,76l-5.86-5.86,1.64-1.64,4.22,4.22L116,63.78l1.64,1.64L107.12,76Z",
    style: {
      fill: "#7ac943"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxInviteAccepted);
export default __webpack_public_path__ + "static/media/gfx-invite-accepted.8aa594c423527d0b202ef9055c180457.svg";
export { ForwardRef as ReactComponent };